import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "workflowContaineer"
};
const _hoisted_2 = {
  class: "workflowTitle"
};
const _hoisted_3 = {
  class: "workflowSubtitle"
};
const _hoisted_4 = {
  class: "workflowTitle"
};
const _hoisted_5 = {
  class: "workflowSubtitle"
};
const _hoisted_6 = {
  ref: "workflowInstanceBlock",
  class: "workflowInstanceBlock"
};
const _hoisted_7 = {
  ref: "workflowEtat",
  class: "workflowEtat"
};
const _hoisted_8 = {
  class: "graph"
};
const _hoisted_9 = {
  class: "etapeGroupe"
};
const _hoisted_10 = {
  class: "workflowGroup inactive"
};
const _hoisted_11 = {
  key: 0,
  class: "transition active"
};
const _hoisted_12 = {
  class: "etapeGroupe"
};
const _hoisted_13 = {
  class: "workflowGroup inactive"
};
const _hoisted_14 = {
  key: 0,
  class: "transition active"
};
const _hoisted_15 = {
  class: "etapeGroupe"
};
const _hoisted_16 = {
  class: "workflowGroup rejected"
};
const _hoisted_17 = {
  key: 0,
  class: "transition active"
};
const _hoisted_18 = {
  class: "etapeGroupe"
};
const _hoisted_19 = {
  class: "workflowGroup active"
};
const _hoisted_20 = {
  key: 0,
  class: "transition inactive"
};
const _hoisted_21 = {
  class: "etapeGroupe"
};
const _hoisted_22 = {
  class: "workflowGroup inactive"
};
const _hoisted_23 = {
  class: "etapeGroupe"
};
const _hoisted_24 = {
  class: "workflowGroup inactive"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_workflow_rejected_block = _resolveComponent("workflow-rejected-block");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.workflow.rejected ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.reject.validation.title")), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.reject.validation.subtitle")), 1)])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.in.validation.title")), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.in.validation.subtitle")), 1)])], 64)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "boxEtape"
  }, [_createElementVNode("div", {
    class: "first"
  })], -1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.send.for.validation.1")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.send.for.validation.2")), 1)])]), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "transition active"
  }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflow.steps, (step, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: step.order,
      class: "ut-step",
      style: {
        "display": "flex",
        "align-items": "center"
      }
    }, [step.order < _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "boxEtape"
    }, [_createElementVNode("div", {
      class: "etape validate"
    }, [_createElementVNode("div", {
      class: "tick"
    })])], -1)), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.validation.group")), 1), _createElementVNode("p", null, _toDisplayString(step.groupName), 1)])])], 64)) : _ctx.workflow.rejected && step.order === _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "boxEtape rejected"
    }, null, -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.validation.group")), 1), _createElementVNode("p", null, _toDisplayString(step.groupName), 1)])])], 64)) : step.order === _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "boxEtape"
    }, [_createElementVNode("div", {
      class: "etape active"
    }, [_createElementVNode("div", {
      class: "rondActif"
    })])], -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.validation.group")), 1), _createElementVNode("p", null, _toDisplayString(step.groupName), 1)])])], 64)) : step.order > _ctx.workflowStep ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "boxEtape"
    }, [_createElementVNode("div", {
      class: "etape inactive"
    }, [_createElementVNode("div", {
      class: "empty"
    })])], -1)), _createElementVNode("div", _hoisted_22, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.validation.group")), 1), _createElementVNode("p", null, _toDisplayString(step.groupName), 1)])])], 64)) : _createCommentVNode("", true)]);
  }), 128)), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "transition inactive"
  }, null, -1)), _createElementVNode("div", _hoisted_23, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "boxEtape"
  }, [_createElementVNode("div", {
    class: "last"
  })], -1)), _createElementVNode("div", _hoisted_24, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.speach.publication.1")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("workflow.graph.speach.publication.2")), 1)])])])], 512)], 512), _ctx.workflow.rejected ? (_openBlock(), _createBlock(_component_workflow_rejected_block, {
    key: 2,
    comment: _ctx.workflow.rejected.comment,
    date: new Date(_ctx.workflow.rejected.date),
    "group-name": _ctx.workflow.rejected.groupName,
    "step-number": _ctx.workflow.rejected.stepNumber,
    "steps-count": _ctx.workflow.steps.length
  }, null, 8, ["comment", "date", "group-name", "step-number", "steps-count"])) : _createCommentVNode("", true)]);
}